import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "teknikdestek";
var destekService = {
    destekTalebi(mesaj, resim) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                mesaj: mesaj,
                resim: resim,
                methodName: "destek"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }
}

export default destekService

